import "./Carousel.scss";

import React from "react";

import {
  ArrowBack,
  ArrowForward,
  ChevronRight
} from "@mui/icons-material";
import {
  Button,
  Grid2,
  IconButton
} from "@mui/material";

import { Media } from "../../contexts/media/MediaContext";
import { ContentCardData } from "../../models/app-data-model";
import ContentCard from "../content-card/ContentCard";

const containerRef = React.createRef();

export type CarouselProps = {
  contentCardGroup: ContentCardData[];
  carouselTitle?: string;
  navTitle?: string;
  navUrl?: string;
};

const Carousel: React.FC<CarouselProps> = (props: CarouselProps) => {
  const containerRef = React.useRef<HTMLElement>(null);

  const contentGroup = props.contentCardGroup && props.contentCardGroup.map((page, index) => (
    <li className="slide" key={index} data-testid={`content-card-${index}`}><ContentCard contentCardData={page} key={index}></ContentCard></li>
  ));
  const carousel_title = props.carouselTitle;
  const nav_title = props.navTitle;


  const scrollTo = (direction: string) => {
    if (direction === 'right' && containerRef.current) {
      containerRef.current.scrollLeft += 600;
    }

    if (direction === 'left' && containerRef.current) {
      containerRef.current.scrollLeft -= 600;
    }
  }

  return (
    <Grid2 className="carousel-container">
       <header className="carousel-title-nav">
          <h3 className="carousel-title">{carousel_title}</h3>
          <Media greaterThanOrEqual="lg" className='desktop'>
          <section className="carousel-scroll" >
            <IconButton color='inherit' id="slide-arrow-next" title="Scroll back" onClick={() => { scrollTo('left') }}>
              <ArrowBack className="arrow" aria-label="back-arrow" />
            </IconButton>
          <IconButton color='inherit' id="slide-arrow-prev" title="Scroll forward" onClick={() => { scrollTo('right') }}>
              <ArrowForward className="arrow" aria-label="forward-arrow" />
            </IconButton>
          </section>
          </Media>
          <Button variant="text" className="carousel-nav">{nav_title}<ChevronRight /></Button>
        </header>
     
      <section className="slides-container" id="slides-container" ref={containerRef} data-testid="slides-container">
        <ul>
          {contentGroup}
        </ul>
      </section>
    </Grid2>
  );
};

export default Carousel;
